import React, { useEffect, useState, useRef } from 'react';
import { io } from 'socket.io-client';
import ReactMarkdown from 'react-markdown';
import StopCircleIcon from '@mui/icons-material/StopCircle';
const LogViewer = ({ isChecked, logEntries, setLogEntries, stopScreenshotUrl, setStopScreenshotUrl, passedinput, changeLogViewer_pos, setChangeLogViewer_pos, stopProcess }) => {
    const logCounter = useRef(0);
    const [connectionStatus, setConnectionStatus] = useState('Disconnected');
    const [stopButton, setStopButton] = useState(false);
    const logContainerRef = useRef(null);
    useEffect(() => {
        const styleSheet = document.createElement("style");
        styleSheet.id = "landingpage-animation-style"; // Changed from "processing-animation-style"
        styleSheet.type = "text/css";
        styleSheet.innerText = `
            @keyframes pulseScale {
                0% { transform: scale(1); }
                50% { transform: scale(1.05); }
                100% { transform: scale(1); }
            }
            .processing-text-animation {
                display: inline-block;
                animation: pulseScale 1.5s infinite ease-in-out;
            }
            @keyframes slideInFromLeft {
                0% { 
                    transform: translateX(-30%);
                    opacity: 0;
                }
                100% { 
                    transform: translateX(0);
                    opacity: 1;
                }
            }
        `;
        // Only add if it doesn't exist yet
        if (!document.getElementById("landingpage-animation-style")) {
            document.head.appendChild(styleSheet);
        }

        // Clean up
        return () => {
            const styleElement = document.getElementById("landingpage-animation-style");
            if (styleElement && styleElement.parentNode) {
                styleElement.parentNode.removeChild(styleElement);
            }
        };
    }, []);
    useEffect(() => {
        stopProcess()
    }, [])
    useEffect(() => {
        let timer;
        if (stopButton) {
            // Reset the state after 2 seconds (2000ms)
            timer = setTimeout(() => setStopButton(false), 2000);
        }
        return () => clearTimeout(timer);
    }, [stopButton]);
    useEffect(() => {
        // console.log('Initializing Socket.IO connection...');
        const socket = io('https://browserusedom.duckdns.org/logs', {
            path: '/socket.io',
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionAttempts: 10,
            reconnectionDelay: 1000,
            timeout: 20000,
            forceNew: false,
            autoConnect: true,
        });

        socket.on('connect', () => {
            // console.log('Connected to /logs namespace');
            setConnectionStatus('Connected');
            setLogEntries((prev) => ({
                ...prev,
                [logCounter.current++]: 'Connected to server logs',
            }));
        });

        socket.on('connect_error', (error) => {
            // console.error('Socket connection error:', error.message);
            setConnectionStatus(`${error.message}. Please refresh the page.`);
            // setLogEntries((prev) => ({ ...prev, [logCounter.current++]: `Connection error: ${error.message}` }));
        });

        socket.on('disconnect', (reason) => {
            // console.log('Disconnected from /logs namespace:', reason);
            setConnectionStatus('Disconnected');
            setLogEntries((prev) => ({
                ...prev,
                [logCounter.current++]: `Disconnected: ${reason}`,
            }));
        });

        socket.on('log_message', (data) => {
            // console.log('Received log message:', data);
            if (!data || typeof data.data !== 'string') {
                console.warn('Invalid log message format:', data);
                return;
            }
            const logMessage = data.data;
            // Early returns for messages to ignore
            if (logMessage.includes('Disconnected:') || !logMessage.startsWith('Agent')) {
                return;
            }
            // Use regex patterns for more precise matching
            const patterns = {
                navigation: /Navigated to https:\/\/(www\.)?google\.com/,
                anyNavigation: /Navigated to /,
                newTab: /Opened new tab with https:\/\/(www\.)?google\.com/,
                browser: /AI Agent initialization /,
                result: /Result:/,
                error: /Result: None/,
                errorNone: /Error: Invalid or Non Existent API key/,
            };
            // Handle navigation events
            if (patterns.navigation.test(logMessage) ||
                patterns.anyNavigation.test(logMessage) ||
                patterns.browser.test(logMessage) ||
                patterns.newTab.test(logMessage)) {
                setStopScreenshotUrl(true);
            }
            // Handle result events
            if (patterns.result.test(logMessage)) {
                stopProcess();
                setStopScreenshotUrl(false);
                // console.log('PROCESS ENDED');
            }
            if (patterns.error.test(logMessage)) {
                stopProcess();
                setStopScreenshotUrl(false);
                // console.log('ERROR');
            }
            if (patterns.errorNone.test(logMessage)) {
                stopProcess();
                setStopScreenshotUrl(false);
                // console.log('ERROR');
            }
            // if (data.data.includes('Task is about to be completed')) {
            //     stopProcess();
            //     setStopScreenshotUrl(false);
            //     console.log('PROCESS ENDED');
            // }
            if (data.data.startsWith('AgentRun')) {
                // Find the index of "]" and trim everything before it, including the "]"
                const bracketIndex = data.data.indexOf(']');
                if (bracketIndex !== -1) {
                    const trimmedMsg = data.data.substring(bracketIndex + 1).trim();
                    setLogEntries((prev) => ({
                        ...prev,
                        [logCounter.current++]: trimmedMsg,
                    }));
                } else {
                    // Fallback to full message if "]" is not found
                    setLogEntries((prev) => ({
                        ...prev,
                        [logCounter.current++]: data.data,
                    }));
                }
            }
        });
        return () => {
            // console.log('Disconnecting Socket.IO...');
            socket.disconnect();
        };
    }, []);
    // console.log('logEntries:', logEntries);
    const renderedLogs = Object.entries(logEntries);

    // const stopProcess = async () => {
    //     try {
    //         const response = await fetch('https://browserusedom.duckdns.org/stop_process', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //         });
    //         if (!response.ok) {
    //             throw new Error(`HTTP error! status: ${response.status}`);
    //         }
    //         const data = await response.json();
    //         setStopScreenshotUrl(false);
    //         setStopButton(true)
    //         console.log('Stop process response:', data);
    //     } catch (error) {
    //         console.error('Error stopping process:', error);
    //     }
    // };
    return (
        <div
            style={{
                // position: stopScreenshotUrl ? 'absolute' : 'relative',
                // marginTop: stopScreenshotUrl ? '108vh' : '1rem',
                display: isChecked ? 'block' : 'none',
                position: changeLogViewer_pos ? 'relative' : 'absolute',
                width: changeLogViewer_pos ? '95vw' : '20vw',
                marginBottom: changeLogViewer_pos ? '13vh' : '',
                marginTop: '0rem',
                padding: '1rem',
                backgroundColor: '#f4f4f4',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontFamily: 'monospace',
                paddingBottom: '3rem',
                right: changeLogViewer_pos ? '' : '1vw',
                animation: changeLogViewer_pos ? 'slideInFromRight 0.5s ease-out forwards' : '',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '0.5rem',
                }}
            >
                <h3 style={{ margin: 0, fontSize: '1.2rem' }}>
                    Log Messages{' '}
                    {/* <span style={{ fontSize: '0.9rem', color: connectionStatus === 'Connected' ? 'green' : 'red', }} >  ({connectionStatus}) </span> */}
                </h3>
                {/* Optionally add controls here */}
                {/* NEW: Button to stop the process and close the browser */}
                {/* <div style={{ margin: '1rem', textAlign: 'center' }}>
                    <span
                        onClick={stopProcess}
                        style={{
                            // padding: '5px 10px',
                            color: stopButton ? 'red' : 'black',
                            cursor: 'pointer',
                            width: '30px',
                        }}
                    >
                        <StopCircleIcon fontSize='large' />
                    </span>

                </div> */}
                {/* {section?.loading && <div className="processing-text-animation" style={{ fontSize: '11px', color: '#999', display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: section?.finalSummary ? '#34de34' : '#34de34', marginRight: '6px' }} />
                    <span >Processing...</span>
                </div>} */}
                {connectionStatus !== 'Connected' && <div style={{ fontSize: '11px', color: '#999', display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: 'red', marginRight: '6px' }} />
                    <span >Connection Error</span>
                </div>}
                {connectionStatus === 'Connected' && <div style={{ fontSize: '11px', color: '#999', display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#34de34', marginRight: '6px' }} />
                    <span >Connected</span>
                </div>}
            </div>
            <div
                ref={logContainerRef}
                style={{
                    // maxHeight: '300px',
                    // overflowY: 'auto',
                    backgroundColor: '#fff',
                    paddingLeft: '0.5rem',
                    border: '1px solid #eee',
                    borderRadius: '4px',
                    width: changeLogViewer_pos ? '94vw' : '20vw',
                }}
            >
                {renderedLogs.length === 0 ? (<p style={{ margin: 0, color: '#666', padding: '23px 0', }}>No log messages yet.</p>)
                    : (
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            {passedinput && <span style={{}} ><ul style={{ marginLeft: '-15px', marginTop: '35px', marginBottom: '10px', fontSize: '16px', fontWeight: '700' }}>{passedinput && "Goal:"} {passedinput}</ul></span>}
                            {renderedLogs.map(([key, msg]) => (
                                <li
                                    key={key}
                                    style={{
                                        fontSize: '14px',
                                        padding: '8px 0',
                                        // borderBottom: '1px solid #f0f0f0',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        color: '#333',
                                        lineHeight: '1.5',
                                    }}
                                >
                                    <div style={{ width: '90vw' }}>
                                        <ReactMarkdown
                                            components={{
                                                // Style for the first-level heading
                                                h1: ({ node, ...props }) => (
                                                    <h1
                                                        style={{
                                                            fontSize: '2.5rem',
                                                            fontWeight: 'bold',
                                                            color: '#333',
                                                            margin: '1rem 0',
                                                        }}
                                                        {...props}
                                                    />
                                                ),
                                                // Style for the second-level heading
                                                h2: ({ node, ...props }) => (
                                                    <h2
                                                        style={{
                                                            fontSize: '2rem',
                                                            fontWeight: 'bold',
                                                            color: '#444',
                                                            margin: '0.8rem 0',
                                                        }}
                                                        {...props}
                                                    />
                                                ),
                                                // Style for the third-level heading
                                                h3: ({ node, ...props }) => (
                                                    <h3
                                                        style={{
                                                            fontSize: '1.75rem',
                                                            fontWeight: 'bold',
                                                            color: '#555',
                                                            margin: '0.8rem 0',
                                                        }}
                                                        {...props}
                                                    />
                                                ),
                                                // Style for paragraphs
                                                p: ({ node, ...props }) => (
                                                    <p
                                                        style={{
                                                            fontSize: '1rem',
                                                            lineHeight: '1.5',
                                                            color: '#666',
                                                            margin: '0.5rem 0',
                                                        }}
                                                        {...props}
                                                    />
                                                ),
                                                // Style for list items
                                                li: ({ node, ...props }) => (
                                                    <li
                                                        style={{
                                                            fontSize: '1rem',
                                                            color: '#666',
                                                            margin: '0.25rem 0',
                                                        }}
                                                        {...props}
                                                    />
                                                ),
                                                // Style for blockquotes
                                                blockquote: ({ node, ...props }) => (
                                                    <blockquote
                                                        style={{
                                                            borderLeft: '4px solid #ddd',
                                                            paddingLeft: '1rem',
                                                            color: '#999',
                                                            margin: '1rem 0',
                                                        }}
                                                        {...props}
                                                    />
                                                ),
                                                // Style for tables
                                                table: ({ node, ...props }) => (
                                                    <table
                                                        style={{
                                                            width: '100%',
                                                            borderCollapse: 'collapse',
                                                            margin: '1rem 0',
                                                        }}
                                                        {...props}
                                                    />
                                                ),
                                                // Style for table header cells
                                                th: ({ node, ...props }) => (
                                                    <th
                                                        style={{
                                                            border: '1px solid #ddd',
                                                            padding: '8px',
                                                            backgroundColor: '#f8f8f8',
                                                            fontWeight: 'bold',
                                                        }}
                                                        {...props}
                                                    />
                                                ),
                                                // Style for table data cells
                                                td: ({ node, ...props }) => (
                                                    <td
                                                        style={{
                                                            border: '1px solid #ddd',
                                                            padding: '8px',
                                                        }}
                                                        {...props}
                                                    />
                                                ),
                                            }}
                                        >
                                            {(() => {
                                                if (msg === "Result: None") return `${msg}, **Please check your API configuration**`;
                                                if (msg === "Error: Invalid or Non Existent API key") return `${msg}, **Please check your API configuration**`;
                                                return msg;
                                            })()}

                                        </ReactMarkdown>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
            </div>
        </div>
    );
};

export default LogViewer;